<base-site-layout
    [heading]="heading | translate"
    [headerIcon]="icon"
    [isDialog]="true"
    (dialogCloseClicked)="cancel()"
>
    <div class="alert alert-light border d-flex align-items-center gap-2 small mb-3">
        <em class="fas fa-circle-info text-muted"></em>
        <span>{{ 'Der Code kann nach dem Anlegen nicht mehr geändert werden.' | translate }}</span>
    </div>

    <form [formGroup]="form">
        <div class="row mb-1">
            <div class="col d-flex flex-column">
                <label>{{ 'Code' | translate }}</label>
                <input
                    formControlName="code"
                    class="form-control"
                    readonly
                />
            </div>
        </div>

        <div class="row mb-1">
            <div class="col d-flex flex-column">
                <label #nameLabel>{{ 'Name' | translate }}</label>
                <input
                    formControlName="name"
                    [label]="nameLabel"
                    errorHighlight
                    mark-required
                    class="form-control"
                    [placeholder]="'Name' | translate"
                    [maxlength]="nameMax"
                />
                <div class="row">
                    @if (form.controls.name.invalid && (form.controls.name.dirty || form.controls.name.touched)) {
                        <span class="col validation-error-indicator">
                            <em class="fas fa-square-xmark pe-1"></em>
                            {{ 'Dies ist ein Pflichtfeld' | translate }}
                        </span>
                    }
                    <div class="col d-flex justify-content-end">
                        <span>{{ nameLength() }} / {{ nameMax }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-1">
            <div class="col d-flex flex-column">
                <label>
                    {{ 'Beschreibung' | translate }}
                    <span class="text-muted fw-normal ms-1">({{ 'optional' | translate }})</span>
                </label>
                <textarea
                    formControlName="description"
                    errorHighlight
                    class="form-control"
                    rows="4"
                    [placeholder]="'Beschreibung der Einkäufergruppe' | translate"
                    [maxlength]="descriptionMax"
                ></textarea>
                <div class="row">
                    <div class="col d-flex justify-content-end">
                        <span>{{ descriptionLength() }} / {{ descriptionMax }}</span>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="saving()">
            <em class="fas fa-arrow-left pe-1"></em>
            {{ 'Abbrechen' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving()">
            <em class="fas fa-check pe-1"></em>
            {{ 'Speichern' | translate }}
        </button>
    </div>
</base-site-layout>
